'use client'
import Link from 'next/link'
import useInscription from '@/utils/hooks/useInscription'
import InscriptionContent from '@/components/inscription-content'
import styles from './offer-dialog.module.css'
import OfferFloor from './offer-floor'

export default function OfferItemSummary({
	id,
	children,
	priceSats,
	onNavigate,
	showFloor = true,
	label,
	hero = false,
	nameTrailing
}: {
	id: string
	children?: React.ReactNode
	priceSats?: number
	onNavigate?: () => void
	/** Receipt layout: the artwork large and centred, the copy beneath it. */
	label?: string
	showFloor?: boolean
	hero?: boolean
	nameTrailing?: React.ReactNode
}) {
	const { data } = useInscription(id)
	const item = data?.id ? data : { id, content_type: 'image/png' }
	return (
		<div className={`${styles.inboxItem} ${hero ? styles.inboxItemHero : ''}`}>
			<div className={styles.inboxThumbnail} aria-hidden="true">
				<InscriptionContent inscription={item} smallCard />
			</div>
			<div className={styles.inboxItemCopy}>
                {label && <span className={styles.itemSummaryLabel}>{label}</span>}
				<div className={styles.itemNameRow}><strong>
					<Link href={`/inscription/${id}`} onClick={onNavigate}>
						{data?.meta?.name ||
							(data?.num ? `Inscription #${data.num}` : `${id.slice(0, 8)}…${id.slice(-6)}`)}
					</Link>
				</strong>{nameTrailing}</div>
				{data?.collection?.name && (
					<span>
						{data.collection.slug ? (
							<Link href={`/collection/${data.collection.slug}`} onClick={onNavigate}>
								{data.collection.name}
							</Link>
						) : (
							data.collection.name
						)}
					</span>
				)}
				{children}
				{showFloor && priceSats != null && data?.collection?.slug && (
					<OfferFloor slug={data.collection.slug} priceSats={priceSats} />
				)}
			</div>
		</div>
	)
}
